import React from 'react'
import Login from "./components/auth/login";
import Register from "./components/auth/register";

import Header from "./components/header";
// import Footer from "./components/partials/footer";
import Home from "./components/home";
import HomeView from "./components/home/view-record.tsx";
import HomeEdit from "./components/home/edit-record.tsx";
import Fans from "./components/fans";
import FanView from "./components/fans/view-record.tsx"
import FanEdit from "./components/fans/edit-record.tsx"
import Releases from "./components/releases";
import ReleaseView from "./components/releases/view-record.tsx";
import ReleaseEdit from "./components/releases/edit-record.tsx";
import Promoters from "./components/promoters";
import PromoterView from "./components/promoters/view-record.tsx";
import PromoterEdit from "./components/promoters/edit-record.tsx";
import Labels from "./components/labels";
import LabelView from "./components/labels/view-record.tsx";
import LabelEdit from "./components/labels/edit-record.tsx";
import ReleaseCalendar from "../src/components/releases/release-calendar.tsx";
import { LeadFanForm } from "../src/components/partials/form-modals/fans/lead-form.tsx";
import { SongShare } from "../src/components/partials/form-modals/catalog/song-share.tsx"
import { ProtectedRoute } from "../src/components/partials/protected-route.tsx";
import Profile from "./components/profile/index.tsx";

import { AuthProvider } from "./contexts/authContext";
import "./App.css";
import { Routes, Route, Navigate } from 'react-router-dom';

function App() {
  return (
	  <AuthProvider>			  
        <Header />
        <div className="w-full flex flex-col">
			<Routes>
				<Route path="*" element={<Navigate to="/login" />} /> {/*Redirect to login if no match*/}
				<Route path="/login" element={<Login />} />
				<Route path="/register" element={<Register />} />	
				<Route path="/leads/:id" element={<LeadFanForm />} />	
				<Route path="/share/:id" element={<SongShare />} />  
				<Route path="/home" >
					<Route index element={<ProtectedRoute><Home /></ProtectedRoute>} />
					<Route path="view/:id" element={<ProtectedRoute><HomeView /></ProtectedRoute>} />
					<Route path="edit/:id" element={<ProtectedRoute><HomeEdit /></ProtectedRoute>} />
				  </Route>
				<Route path="/profile">
					  <Route index element={<ProtectedRoute><Profile /></ProtectedRoute>} />
				</Route>
				<Route path="/fans">
					<Route index element={<ProtectedRoute><Fans /></ProtectedRoute>} />
					<Route path="view/:id" element={<ProtectedRoute><FanView /></ProtectedRoute>} />
					<Route path="edit/:id" element={<ProtectedRoute><FanEdit /></ProtectedRoute>} />
				</Route>
				<Route path="/releases" >
						<Route index element={<ProtectedRoute><Releases /></ProtectedRoute>} />
						<Route path="calendar" element={<ProtectedRoute><ReleaseCalendar /></ProtectedRoute>} />
						<Route path="view/:id" element={<ProtectedRoute><ReleaseView /></ProtectedRoute>} />
						<Route path="edit/:id" element={<ProtectedRoute><ReleaseEdit /></ProtectedRoute>} />
				</Route>
				<Route path="/labels">
						<Route index element={<ProtectedRoute><Labels /></ProtectedRoute>} />
						<Route path="view/:id" element={<ProtectedRoute><LabelView /></ProtectedRoute>} />
						<Route path="edit/:id" element={<ProtectedRoute><LabelEdit /></ProtectedRoute>} />
				</Route>
				<Route path="/promoters" >
					<Route index element={<ProtectedRoute><Promoters /></ProtectedRoute>} />
					<Route path="view/:id" element={<ProtectedRoute><PromoterView /></ProtectedRoute>} />
					<Route path="edit/:id" element={<ProtectedRoute><PromoterEdit /></ProtectedRoute>} />
				</Route>
			</Routes>
        </div>
        {/* <Footer /> */}
    </AuthProvider>
  );
}

export default App;
